import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";

const registrationBreadcrumb = breadcrumbSlot();

export const registrationRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Registrations" },
    children: [
      {
        index: true,
        async lazy() {
          const { Registrations } = await import("./registrations");
          return { element: <Registrations /> };
        },
      },
      {
        path: ":registrationId",
        handle: { breadcrumb: registrationBreadcrumb },
        async lazy() {
          const { RegistrationPage } = await import("./registration");
          return {
            element: <RegistrationPage breadcrumb={registrationBreadcrumb} />,
          };
        },
      },
      {
        handle: { breadcrumb: "Create Registration" },
        path: "create-registration",
        async lazy() {
          const { CreateRegistrationPage } =
            await import("./create-registration");
          return {
            element: (
              <CreateRegistrationPage breadcrumb={registrationBreadcrumb} />
            ),
          };
        },
      },
    ],
  },
];
